/**
 *
 * Asynchronously loads the component for SubscriptionsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SubscriptionsPage = lazyLoad(
  () => import('./index'),
  module => module.SubscriptionsPage,
);
